// ** React Imports
import { Link } from "react-router-dom";
import { useEffect } from "react";
// ** Custom Components
import Avatar from "@components/avatar";
import { handleLogout } from "@store/action/auth/AuthAction";
import { Settings, Power } from "react-feather";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import defaultAvatar from "@src/views/BackOffice/studio/assets/img/Avatar-Profile-PNG-Picture.png";
import { useDispatch, useSelector } from "react-redux";
import { getAuthUser } from "@store/action/auth/AuthAction";

const radio_id = localStorage.getItem("radio_id");

const UserDropdown = ({ t }) => {
  // ** State
  const dispatch = useDispatch();
  const AuthReducer = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(getAuthUser());
  }, []);

  const userAvatar = AuthReducer.userData.avatar
    ? AuthReducer.userData.avatar
    : defaultAvatar;

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name fw-bold">
            {(AuthReducer.userData.id &&
              `${AuthReducer.userData.last_name} ${AuthReducer.userData.first_name}`) ||
              " "}
          </span>
          <span className="user-status">
            {AuthReducer.userData.roles
              ? AuthReducer?.userData?.roles.length > 0
                ? t(AuthReducer.userData.roles[0].name)
                : t(
                    AuthReducer.userData.user_teams.find(
                      (el) => el.team.product_id == radio_id
                    ).role.name
                  )
              : ""}
          </span>
        </div>
        <Avatar img={userAvatar} imgHeight="40" imgWidth="40" status="online" />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to="/admin/profile">
          <Settings size={14} className="me-75" />
          <span className="align-middle">{t("Settings")}</span>
        </DropdownItem>

        <DropdownItem tag="a" onClick={() => dispatch(handleLogout())}>
          <Power size={14} className="me-75" />
          <span className="align-middle">{t("Logout")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
